export enum GrantTypesEnum {
  password = 'password',
  authorization_code = 'authorization_code',
  refresh_token = 'refresh_token',
}
